import { ITagsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class AddTagsToWorkbooksRequest extends Request<ITagsParams, IResult> {
  constructor(ids: string[], tags: string[]) {
    super('addTagsToWorkbooks', {
      ids: ids,
      tags: tags
    });
  }
}
